import React from 'react';
import classNames from 'classnames';

const BookCover = ({ url, faded, large }) => {

    return (
        <div className={classNames("item-cover", { large })}>
            <div
                className={classNames("item-cover-image")}
                style={{backgroundImage: `url(${url})`, filter: faded ? 'brightness(0.6)' : null }}
            />
        </div>
    );
};

export default BookCover;
